import React from 'react';
import {StopperIcon} from '../../Icons';
import {StopperTooltip} from './StopperTooltip';
import className from './style.module.scss';
import {Image} from '@learningblocks/shared-components';

export function Stopper(props) {
  const [hover, setHover] = React.useState(false);

  const toggleHover = (value) => () => setHover(value);

  return (
    <div
      tabIndex='0'
      className={className.stopper}
      onMouseEnter={toggleHover(true)}
      onMouseLeave={toggleHover(false)}>
      <StopperTooltip selected={hover} buttonList={ props.buttonList }/>
      <Image src={StopperIcon} alt='stopper-image' />
    </div>
  );
}

Stopper.propTypes = {};

Stopper.defaultProps = {};
